"use strict";

import * as Video from "components/Video";
import * as BasicAnchorLinks from "components/BasicAnchorLinks";
document.addEventListener("DOMContentLoaded", function () {
  Video.init();
  BasicAnchorLinks.init();
});
window.addEventListener("load", function () {});
